export const DEFAULT_MAX_DISPLAY_PARTICIPANTS = 12;

export const calcMaxDisplayParticipantsInGridMobile = () => {
    // Для расчета берем меньшую сторону, чтобы в альбомной ориентации устройства тоже было корректное количество слотов
    const width = Math.min(window.innerWidth, window.innerHeight);

    if (width < 480) {
        return 4;
    }

    if (width < 768) {
        return 8;
    }

    return DEFAULT_MAX_DISPLAY_PARTICIPANTS;
};
